<template>

  <div class="ob-content">
    <loader :condition="dataLoaded">
      <toolbar>
        <template v-slot:head>
          {{ item.name }}
        </template>

        <template v-slot:controls>
          <v-btn color="primary" @click="saveItem()">{{ $t('save') }}</v-btn>
          <v-btn @click="$router.go(-1)">{{ $t('cancel') }}</v-btn>
          <v-btn color="error" @click="onDestroy(item)">{{ $t('archive') }}</v-btn>
        </template>
      </toolbar>

      <div class="ob-grid">
        <v-card class="ob-col-6">
          <asset-type-form :asset-type="item"></asset-type-form>
        </v-card>

        <v-card class="ob-col-6">
          <asset-type-attributes :asset-type="item" @change="refresh()"></asset-type-attributes>
        </v-card>

        <v-card class="ob-col-6" v-if="$canm('mnt', 'useChecklists')">
          <asset-type-checklists :asset-type="item" @change="refresh()" @remove="refresh()"></asset-type-checklists>
        </v-card>

        <v-card class="ob-col-6">
          <asset-type-files :asset-type="item"></asset-type-files>
        </v-card>
      </div>

    </loader>
  </div>

</template>

<script>
import itemHelpers from '../helpers/item-helpers.es6'
import Toolbar from '../shared/toolbar'
import Loader from '../shared/loader'
import AssetTypeForm from './components/asset-type-form'
import AssetTypeAttributes from './components/asset-type-attributes'
import AssetTypeFiles from './components/asset-type-files'
import AssetTypeChecklists from './components/asset-attributes/asset-type-checklists'

export default {
  mixins: [itemHelpers],

  data () {
    return {
      model: { name: 'asset-types' },
      auxModels: [
        { name: 'checklists' }
      ]
    }
  },

  methods: {
    async refresh () {
      await this.saveItem(true)
    },

    async saveItem (silent) {
      await this.save({ reRoute: !silent, snackbar: !silent, saveitem: !silent })
      await this.storeUpdate()
    }
  },

  components: {
    AssetTypeChecklists,
    AssetTypeFiles,
    Loader,
    Toolbar,
    AssetTypeForm,
    AssetTypeAttributes
  }
}
</script>
